import { gql } from '@apollo/client'

export const GET_MY_CHANNELS = gql`
  query GetMyChannels {
    myChannels {
      id
      name
      followersCount
    }
  }
`
